define([
	"csi/api",
	"csi/canvas/storeFactory",
	"csi/locale",
	"csi/reflection",
	"csi/xml"
], function (api, storeFactory, locale, reflection, xml) {

	var TEST = "Test";
	var TEST_RUN_REVISION = "TestRunRevision";
	var TEST_RUN_SECTION = "TestRunSection";

	storeFactory.add(TEST_RUN_REVISION, TEST_RUN_SECTION, "Child:TestRunSections");
	storeFactory.add(TEST_RUN_REVISION, TEST, "Child:TestRunSections/Child:Tests");


	// if single section review do not show section on the breadcrumb
	api.addLinkValidation("QuestionSection", (node) => {
		const factoryConfig = reflection.getObject("centric://REFLECTION/INSTANCE/FactoryConfig");
		return !factoryConfig || !factoryConfig.SingleSectionReview;
	});

	api.addLinkValidation("TestSpec", ({ __Parent__ }) => !xml.isValidURL(__Parent__));

	return {
		postActionTestRunAddTests: function (ac) {
			ac.widget.getToolbarContainerView().refreshWidget();
		},

		postActionRefreshDocumentsView: function (ac) {
			var view = ac.widget.viewParent.getChildView("Documents");
			if (view)
				view.refreshWidget(true);
		},

		postApproveAction: function (ac) {
			//refresh both current view and the approved contractual documents view
			ac.widget.refreshWidget(true);
			var view = ac.widget.viewParent.getChildView("SupplierContractualDocumentsApproved");
			if (view) {
				view.refreshWidget(true);
			}
		},

		onAccessActionEdit: function (/*Context*/ctx, /*Action*/action) {
			return false;
		},

		onAccessActionNewContractualDocumentFromSourceObject: function (/*Context*/ctx, /*Action*/action) {
			var sourceObjectRev = ctx.cache.getChildNode(ctx.getParent(), "CurrentRevision", true);
			return sourceObjectRev.State == "Revision.State:APPROVED";
		}
	};
});
